import {RouterProps} from "../../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";

export default function ChargeRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:assetStarChargeId'} element={<Detail {...props} />} />
        </Routes>
    </>
}